var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AuthCache from './AuthCache';
import { v4 as uuid } from 'uuid';
import { fetchAuthSession, signOut, updateUserAttribute } from 'aws-amplify/auth';
import { UserPropertyKeys } from './UserProperties';
export function checkForcedLogout(error) {
    switch (('' + error).trim() //Force a typecast that can be compared
    ) {
        case 'NotAuthorizedException: Access Token has been revoked':
            handleForcedLogout();
            break;
        case 'No current user':
            //Depending on context, such as the login screen, this could be ok
            //and is NOT a sign of a forced logout
            break;
        case 'UserNotFoundException: User does not exist.':
            //Depending on context, such as the login screen, this could be ok
            //and is NOT a sign of a forced logout
            break;
        case 'Error: Session is invalid':
            //Depending on context, such as the login screen, this could be ok
            //and is NOT a sign of a forced logout
            break;
        case 'Network error':
            console.error('No network (no prefix)', error);
            break;
        case 'Error: Network error (had prefix)':
            console.error('No network', error);
            break;
        default:
            console.warn('Authentication error is unknown:', error);
    }
}
export function logOut(handleAdditionalTeardown) {
    return __awaiter(this, void 0, void 0, function () {
        var isAuthenticated, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    return [4 /*yield*/, isCurrentUserAuthenticated()];
                case 1:
                    isAuthenticated = _a.sent();
                    if (!isAuthenticated) return [3 /*break*/, 5];
                    if (!handleAdditionalTeardown) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleAdditionalTeardown()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, signOut()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_1 = _a.sent();
                    if (err_1 === 'No current user') {
                        //This edge case usually happens when you manually clear the application's data and then try to log out
                    }
                    else {
                        console.error('Unhandled Sign-out error', err_1);
                    }
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function logOutOthers() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
}
export function handleForcedLogout() {
    console.error('Forced logout needs implemented');
    //TODO: Implement a UI notice for forced sign-out due to buddy login or explicit serverside logout
    try {
        signOut();
        AuthCache.invalidateCache();
    }
    catch (exception) {
        console.error('Attempting to force a logout there was an error', exception);
    }
}
export function getCurrentUser() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var tokens, user;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, isCurrentUserAuthenticated()];
                case 1:
                    if (!(_b.sent()))
                        return [2 /*return*/, undefined];
                    return [4 /*yield*/, fetchAuthSession()];
                case 2:
                    tokens = (_b.sent()).tokens;
                    user = (_a = tokens === null || tokens === void 0 ? void 0 : tokens.idToken) === null || _a === void 0 ? void 0 : _a.payload;
                    return [2 /*return*/, user];
            }
        });
    });
}
export function getCurrentUserStringAttribute(attributeName) {
    return __awaiter(this, void 0, void 0, function () {
        var user, attributeValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCurrentUser()];
                case 1:
                    user = _a.sent();
                    attributeValue = user === null || user === void 0 ? void 0 : user[attributeName];
                    if (Array.isArray(attributeValue)) {
                        if (attributeValue.length === 0)
                            return [2 /*return*/, undefined];
                        return [2 /*return*/, attributeValue[0]];
                    }
                    return [2 /*return*/, attributeValue];
            }
        });
    });
}
export function getCurrentUserStringArrayAttribute(attributeName) {
    return __awaiter(this, void 0, void 0, function () {
        var user, attributeValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCurrentUser()];
                case 1:
                    user = _a.sent();
                    attributeValue = user === null || user === void 0 ? void 0 : user[attributeName];
                    if (Array.isArray(attributeValue)) {
                        return [2 /*return*/, attributeValue];
                    }
                    else if (typeof attributeValue === 'string') {
                        return [2 /*return*/, [attributeValue]];
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
export function getCurrentUserAttribute(attributeName) {
    return __awaiter(this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCurrentUser()];
                case 1:
                    user = _a.sent();
                    return [2 /*return*/, user === null || user === void 0 ? void 0 : user[attributeName]];
            }
        });
    });
}
export function updateCurrentUserAttribute(attributeName, attributeValue) {
    return __awaiter(this, void 0, void 0, function () {
        var preparedValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isCurrentUserAuthenticated()];
                case 1:
                    if (!(_a.sent()))
                        return [2 /*return*/];
                    preparedValue = prepareValue(attributeName, attributeValue);
                    return [4 /*yield*/, updateUserAttribute({
                            userAttribute: {
                                attributeKey: attributeName,
                                value: preparedValue,
                            },
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Certain AWS fields, especially phone_number, have strict formatting requirements.
 * See https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
 * We implement those here (where possible)
 */
function prepareValue(attributeName, attributeValue) {
    if (attributeName === 'phone_number') {
        return awsFormatPhone(attributeValue);
    }
    return attributeValue;
}
/**
 * This function fulfils the
 * "A phone number must start with a plus (+) sign, followed immediately by the country code. A phone number can only contain the + sign and digits. You must remove any other characters from a phone number, such as parentheses, spaces, or dashes (-) before submitting the value to the service."
 * requirement in AWS (https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html),
 * but assumes that the phone is US if no explicit country code is given.
 * AWS has some undocumented implicitly defined formatting requirements that appear to be based on country code
 * @param oldPhone
 */
function awsFormatPhone(oldPhone) {
    var result = oldPhone.trim().replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '');
    if (result.startsWith('+'))
        return result; //If there appears to be a country code provided, use it
    return '+' + result;
}
export function isCurrentUserAuthenticated() {
    return __awaiter(this, void 0, void 0, function () {
        var tokens;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAuthSession()];
                case 1:
                    tokens = (_a.sent()).tokens;
                    return [2 /*return*/, tokens !== undefined];
            }
        });
    });
}
export function getIDTokenAsString() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var tokens, exception_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchAuthSession()];
                case 1:
                    tokens = (_b.sent()).tokens;
                    return [2 /*return*/, (_a = tokens === null || tokens === void 0 ? void 0 : tokens.idToken) === null || _a === void 0 ? void 0 : _a.toString()];
                case 2:
                    exception_1 = _b.sent();
                    checkForcedLogout(exception_1);
                    throw new Error('Failed to get ID token');
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function ensureUserHasId() {
    return __awaiter(this, void 0, void 0, function () {
        var userId, newUserId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCurrentUserStringAttribute(UserPropertyKeys.userID)];
                case 1:
                    userId = _a.sent();
                    if (!!userId) return [3 /*break*/, 3];
                    newUserId = uuid();
                    return [4 /*yield*/, updateCurrentUserAttribute(UserPropertyKeys.userID, newUserId)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
